import React from 'react';
import { useTranslation } from 'react-i18next';
import TabSection from './TabSection';
import cadLogo from '../assets/logos/cad-logo.svg';
import esdcLogo from '../assets/logos/esdc-edsc.png';


const Footer = ({
  activeSectionId,
  setActiveSectionId,
  setCurrentVideoUrl,
  setVideoSidebarOpen,
  setVideoLabels,
  setSelectedVideoIndex,
  setAllVideoUrls,
  registerSection,
  unregisterSection,
}) => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="wrapper">
      <TabSection
        videoUrls={["/ASL/DISC ASL Footer.mp4", "/LSQ/Footer LSQ.mp4"]}
        videoLabels={["ASL", "LSQ"]}
        sectionId="sections.footer"
        activeSectionId={activeSectionId}
        setActiveSectionId={setActiveSectionId}
        setCurrentVideoUrl={setCurrentVideoUrl}
        setVideoSidebarOpen={setVideoSidebarOpen}
        setVideoLabels={setVideoLabels}
        setSelectedVideoIndex={setSelectedVideoIndex}
        setAllVideoUrls={setAllVideoUrls}
        registerSection={registerSection}
        unregisterSection={unregisterSection}
      >
        <div className="footer-content">
          <div className="footer-top">
            <div className="footer-logo1">
              <h6>{t('footer.brought-by')}</h6>
              <a href="http://cad-asc.ca" target="_blank" rel="noopener noreferrer">
                <img className="footer-logo-image" src={cadLogo} alt={t('footer.cad-logo-alt')} />
              </a>
            </div>
            <div className="footer-logo2">
              <h6>{t('footer.funded-by')}</h6>
              <a href="http://esdc-edsc.gc.ca" target="_blank" rel="noopener noreferrer">
                <img className="footer-logo-image" src={esdcLogo} alt={t('footer.esdc-logo-alt')} />
              </a>
            </div>
          </div>


          <div className="footer-bottom">

            <div className="copyright-info">
              <span>&copy; Canadian Association of the Deaf</span>
              <span>Association des Sourds du Canada</span>
            </div>

            <div className="contact-info">
              <span>{t('footer.address')}</span>

              <span>{t('footer.phone')}</span>

              <span>
                <a href="mailto:info@cad-asc.ca">info@cad-asc.ca</a>
              </span>

              <span>
                <a href="http://cad-asc.ca" target="_blank" rel="noopener noreferrer">cad-asc.ca</a>
              </span>
            </div>

          </div>

          <hr className="footer-divider" />

          <div className="footer-credits">
            <span>
              {t('footer.credits-asl')}{' '}
              <a href="https://asign.ca/" target="_blank" rel="noopener noreferrer">{t('footer.asign')}</a>
            </span>
            <span>
              {t('footer.credits-web')}{' '}
              <a href="https://cyansolutions.com" target="_blank" rel="noopener noreferrer">{t('footer.cyan')}</a>
            </span>
          </div>
        </div>
      </TabSection>
      </div>
    </footer>
  );
};

export default Footer;
